import { jsx as _jsx } from "react/jsx-runtime";
import Stick from '../../../es';
import Regression from './Regression';
export default function SameWidth() {
    return (_jsx(Regression, { allBrowsers: true, version: "1.0.0", fixed: true, title: "SVG node as anchor", description: "Stick should also be usable inside an SVG", children: _jsx("svg", { width: "400", height: "200", children: _jsx(Stick, { component: "g", position: "top center", node: _jsx("div", { style: {
                        height: 20,
                        width: 20,
                        backgroundColor: '#ae0d5c',
                    } }), children: _jsx("ellipse", { cx: "200", cy: "100", rx: "100", ry: "50", style: { fill: 'rgb(24, 170, 177)' } }) }) }) }));
}
